import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';

import { RelatorioFinanceiroComponent } from './components/relatorio-financeiro.component';
import { RelatorioFinanceiroApiService } from './services/relatorio-financeiro-api.service';
import { RelatorioFinanceiroResolver } from './relatorio-financeiro.resolver';
import { RelatorioLancamentosComponent } from './components/relatorio-lancamentos/relatorio-lancamentos.component';
import { RelatorioGraficosComponent } from './components/relatorio-graficos/relatorio-graficos.component';
import { CadastroLoteLancamentosDialogModule } from '../../../shared/dialogs/cadastro-lote-lancamentos-dialog/cadastro-lote-lancamentos-dialog.module';
import { ExibeCorrespondenciaDialogModule } from '../../../shared/dialogs/exibe-correspondencia-dialog/exibe-correspondencia-dialog.module';

@NgModule({
  declarations: [
    RelatorioFinanceiroComponent,
    RelatorioLancamentosComponent,
    RelatorioGraficosComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
    FormsModule,
    CadastroLoteLancamentosDialogModule,
    ExibeCorrespondenciaDialogModule,
  ],
  providers: [
    { provide: RelatorioFinanceiroApiService, useClass: RelatorioFinanceiroApiService },
    RelatorioFinanceiroResolver,
  ],
})
export class RelatorioFinanceiroModule { }
